export const formatLabel = (key) => {
  return key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b(id)\b/i, "ID")
    .replace(/\b(url)\b/i, "URL")
    .replace(/\b(ssn)\b/i, "SSN")
    .replace(/\b(otp)\b/i, "OTP")
    .replace(/number$/i, "No.")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
};
